import { Box, Modal, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EmployeeIssue } from "../../services/branch-service";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  maxHeight: "80vh",
  overflowY: "auto",
  bgcolor: "#fff",
  border: "1px solid #898989",
  boxShadow: 24,
  borderRadius: 4,
};

interface EmployeeValidationWarningModalProps {
  isOpen: boolean;
  employees: EmployeeIssue[];
  onClose: () => void;
}

export function EmployeeValidationWarningModal({
  isOpen,
  employees,
  onClose,
}: EmployeeValidationWarningModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="employee-validation-warning-title"
    >
      <Box sx={style}>
        <div className="bg-gray-light text-center text-lg font-normal text-black py-6 px-2">
          <h1 className="text-lg font-normal">
            {t("branches.employee-validation.warning-title")}
          </h1>
        </div>
        <div className="p-6">
          <div className="flex flex-col gap-4">
            <p className="text-sm text-gray-600">
              {t("branches.employee-validation.warning-description")}
            </p>

            <div className="flex flex-col gap-3">
              {employees.map((employee) => (
                <div
                  key={employee.userId}
                  className="border border-gray-200 rounded-lg p-4 bg-gray-50"
                >
                  <div className="flex flex-col gap-2">
                    <h3 className="font-medium text-gray-800">
                      {employee.name}
                    </h3>
                    <p className="text-sm text-gray-600">{employee.email}</p>
                    <div className="flex items-center gap-2 mt-2">
                      <svg
                        className="w-4 h-4"
                        style={{ color: "#EF0BB8" }}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-sm font-medium" style={{ color: "#EF0BB8" }}>
                        {employee.reason}
                      </span>
                    </div>
                    <div className="flex gap-2 mt-1">
                      {!employee.isVerified && (
                        <span className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs" style={{ borderColor: "#EF0BB8", color: "#EF0BB8" }}>
                          {t("branches.employee-validation.not-verified")}
                        </span>
                      )}
                      {!employee.hasSchedule && (
                        <span className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs" style={{ borderColor: "#EF0BB8", color: "#EF0BB8" }}>
                          {t("branches.employee-validation.no-schedule")}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex justify-end mt-4">
              <Button
                onClick={onClose}
                sx={{
                  color: "#fff",
                  fontFamily: "Montserrat",
                  fontWeight: 300,
                  background: "#EF0BB8",
                  border: "1px solid #EF0BB8",
                  borderRadius: "16px",
                  padding: "8px 24px",
                  textTransform: "none",
                  "&:hover": {
                    background: "#d109a3",
                  },
                }}
              >
                {t("branches.employee-validation.close")}
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export {};
